import { ImportCommentsButton, ExportCommentsButton } from 'feature/developer/import-export';
import { demoFile, componentWithVariants, variant, story, CLICK, INPUT, POPUP, feature } from 'system/demo';

demoFile('feature/developer/import-export');

componentWithVariants('ImportCommentsButton', ImportCommentsButton, {}, [
    variant('Warning outside test silo', {
        siloKey: 'prod',
        state: { roles: ['Developer'] }
    }),
    variant('Import comments', {
        siloKey: 'puppet-test',
        state: { roles: ['Developer'], personaKey: 'p', collections: {comment: []} }
    }, [
        story('Import', [
            CLICK('!Import Comments'),
            POPUP(INPUT('import-comments-input', 'first\nsecond')),
            POPUP(CLICK('!Import Comments'))
        ])
    ])
]);

componentWithVariants('ExportCommentsButton', ExportCommentsButton, {}, [
    variant('Hidden without capability', {}),
    variant('Export comments', {
        state: { roles: ['Developer'], personaKey: 'p', collections: {comment: [
            {key: '1', from: 'a', text: 'hello'},
            {key: '2', from: 'b', replyTo: '1', text: 'reply'},
            {key: '3', from: 'a', text: 'world'}
        ]}}
    }, [
        story('Open', [CLICK('!Export Comments')])
    ])
]);

feature('import-comments', {structureKey: 'simplecomments'});
feature('export-comments', {structureKey: 'simplecomments'});

